






























import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Ref} from "vue-property-decorator"
import JdhSneakPeek from "@/design-system/shared/JdhSneakPeek.vue"

/**
 * @status stable
 * @published 5.8.0
 * @changelog 5.8.0 Published.
 */
@Component({
    components: {JdhSneakPeek}
})
export default class JdsReaction extends Vue {

    @Prop() type!: string
    @Prop() value!: number
    @Prop({type: Boolean, default: false}) active!: boolean
    @Ref() anchorEl!: HTMLElement

    showTooltip = false

    emitClick() {
        this.$emit('click')
    }
}
